module.exports = __webpack_public_path__ + "statics/img/LogisticsPartners-1.fc581bc2.png";